import { faEdit, faReceipt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import { ListarGruposVinculadosPorModuloController } from "../../../Controllers/Repasse/EtapasGrupo/EtapasGrupoController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IListarEtapasGrupo } from "../../../Interfaces/Repasse/EtapasGrupo/EtapasGrupoInterface";
import EditarGrupoModal from "../AtendimentoRepasse/EditarEtapaGrupoModal";
import { useModuloInfo } from "../../../Context/ModuloInfo";

interface IEtapasGrupoProps {}

export default function EtapasGrupo(props: IEtapasGrupoProps) {
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const { id } = useModuloInfo();

    const {
        value: gruposRepasse,
        loading: gruposRepasseLoading,
        // execute: updateList,
    } = useAsyncEffect(
        () => ListarGruposVinculadosPorModuloController(id ?? 0),
        [id]
    );

    const tableviewColumns: Array<ColumnDescription<IListarEtapasGrupo>> = [
        {
            dataField: "DS_GRUPO",
            text: "",
            formatter: (c, row) => (
                <div className="d-flex flex-md-nowrap flex-wrap justify-content-between p-3">
                    <div>
                        <h6>{c}</h6>
                        <div>{row.DS_GRUPO}</div>
                    </div>

                    <div className="Button-Tools">
                        <button
                            className="btn btn-outline-primary font-weight-bold mr-2 "
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Etapas Grupo",
                                    IconHeader: faReceipt,
                                    Component: () => (
                                        <EditarGrupoModal
                                            idGrupo={row.ID_GRUPO}
                                            setShow={setShow}
                                        />
                                    ),
                                    size: "xl",
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faEdit} size="lg" />{" "}
                            <span className="d-none d-sm-block">Editar</span>
                        </button>
                    </div>
                </div>
            ),
        },
    ];

    return (
        <div className="card card-custom p-4">
            <div className="d-flex align-items-center">
                <h3 className="card-title align-items-start ">
                    <span className="card-label font-weight-bolder text-dark">
                        Etapas por Grupo
                    </span>
                </h3>
            </div>
            <Table
                wrapperClasses="mw-100 custom-scroll"
                columns={tableviewColumns}
                data={gruposRepasse ?? []}
                loading={gruposRepasseLoading}
                keyField="ID_FORMULARIO"
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum Grupo Encontrado
                    </div>
                )}
                noHover
                noSearch
                bordered={false}
                striped={true}
                rowClasses={"rowClasses"}
                center={true}
            />

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
